import React from 'react';
import { getWeatherConditionIcon } from '../utils';

const CSS = `
  .gong-forecast { margin-bottom: 8px; animation: fadeUp 0.45s 0.32s ease both; }
  .gong-forecast-strip { display: flex; gap: 4px; overflow-x: auto; padding-bottom: 4px; padding-top: 12px; }
  .gong-fc-card { flex: 1; min-width: 0; background: rgba(255,255,255,0.02); border: 1px solid rgba(240,236,224,0.09); border-radius: 2px; padding: 5px 4px; text-align: center; position: relative; transition: border-color 0.15s; }
  .gong-fc-card:hover { border-color: rgba(240,236,224,0.22); }
  .gong-fc-card.best { border-color: #ffaa44; background: rgba(255,170,68,0.07); }
  .gong-fc-best-badge { position: absolute; top: -9px; left: 50%; transform: translateX(-50%); background: #ffaa44; color: #111; font-family: 'DM Mono', monospace; font-size: 7px; letter-spacing: 0.1em; padding: 2px 6px; border-radius: 2px; white-space: nowrap; }
  .gong-fc-day { font-family: 'DM Mono', monospace; font-size: 9px; letter-spacing: 0.12em; color: rgba(240,236,224,0.3); text-transform: uppercase; margin-bottom: 3px; }
  .gong-fc-icon { font-size: 16px; line-height: 1; margin-bottom: 2px; }
  .gong-fc-temp { font-family: 'Josefin Sans', sans-serif; font-size: 11px; font-weight: 600; color: #f0ece0; margin-bottom: 3px; }
  .gong-fc-pill { display: inline-block; font-family: 'DM Mono', monospace; font-size: 9px; letter-spacing: 0.06em; padding: 2px 5px; border-radius: 20px; min-width: 28px; }
  .gong-fc-pill.green { background: rgba(111,207,151,0.15); color: #6fcf97; }
  .gong-fc-pill.amber { background: rgba(242,153,74,0.15);  color: #f2994a; }
  .gong-fc-pill.red   { background: rgba(235,87,87,0.15);   color: #eb5757; }
`;

function calcDayScore(day) {
  const tempF = day.temp * 9/5 + 32;
  const t = tempF >= 60 && tempF <= 85 ? 100 : tempF >= 50 ? 75 : tempF >= 40 ? 50 : 10;
  const p = ['Rain','Snow','Drizzle'].includes(day.condition) || day.rainProbability >= 50 ? 0 : day.rainProbability >= 10 ? 50 : 100;
  const w = (day.windSpeed * 3.6) <= 15 ? 100 : (day.windSpeed * 3.6) <= 30 ? 50 : 10;
  return Math.min(100, Math.max(0, Math.round(t * 0.25 + p * 0.45 + w * 0.20)));
}

function pillClass(s) { return s >= 70 ? 'green' : s >= 50 ? 'amber' : 'red'; }

export default function ForecastStrip({ forecast, unit }) {
  if (!forecast?.length) return null;

  const scored = forecast.map(d => ({ ...d, score: calcDayScore(d) }));
  const bestIdx = scored.reduce((bi, d, i) => d.score > scored[bi].score ? i : bi, 0);

  return (
    <>
      <style>{CSS}</style>
      <div className="gong-forecast">
        <div className="gong-divider" style={{ marginBottom: 16 }}><span>COMING DAYS</span></div>
        <div className="gong-forecast-strip">
          {scored.map((day, i) => {
            const temp = unit === 'celsius' ? `${day.temp}°C` : `${Math.round(day.temp * 9/5 + 32)}°F`;
            return (
              <div key={i} className={`gong-fc-card${i === bestIdx ? ' best' : ''}`}>
                {i === bestIdx && <span className="gong-fc-best-badge">BEST</span>}
                <div className="gong-fc-day">{day.day}</div>
                <div className="gong-fc-icon">{getWeatherConditionIcon(day.condition, true, day.condition)}</div>
                <div className="gong-fc-temp">{temp}</div>
                <span className={`gong-fc-pill ${pillClass(day.score)}`}>{day.score}</span>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
